// Quote,name,location,course
module.exports = [
  [
    'The thanks must come from me – what an exceptional day it was for our team, all of who took so much away from it. Thank you so, so much. Your help last minute was amazing and I cannot thank you enough.',
    'Butlins',
    'Bognor Regis',
    'Deaf Awareness Training'
  ],
  [
    'I am so glad a friend recommended to me to try “BSLcourses”...the whole team were so understanding of my physical difficulties. Online learning is definitely the way forward for me. It enables you to go at your own pace without stress.',
    'Ruth Rice',
    'Hassocks, West Sussex',
    'Level 1 BSL Training'
  ],
  [
    'When I started studying, my working hours were unpredictable so being able to book tutorials when I was available was perfect for me.',
    'Abigail Apps',
    'Glasgow',
    'Level 1 Award in BSL; Level 2 Certificate in BSL'
  ],
  [
    'We are two sisters who signed up and completed the Level 2 and 3 BSL Training package and are both so happy we did. The whole learning experience was very enjoyable and the one-to-one sessions with the tutor were always friendly, fun and we always came away looking forward to the next one.',
    'Amie and Jody Gooch',
    'Llanelli, Wales',
    'Levels 2 and 3 BSL Training'
  ],
  [
    'The student support is great; the course is professional and organised and the service is very personal and understanding.',
    'Aeneas Brewster',
    'Doncaster',
    'Level 2 BSL Training'
  ],
  [
    'There are lots of time built in to the course to address any problems that have come up or to ask questions. I would thoroughly recommend this course to anyone looking for a flexible course with lots of one-to-one time.',
    'Sune Kuhn',
    'Hamilton, Scotland',
    'Level 1 Award in BSL Studies'
  ],
  [
    'The people involved with BSLcourses.co.uk really care about their students and I believe they would do just about anything to help - way beyond the call of duty!',
    'Brett Best',
    'Miami, USA',
    'Level 6 Certificate in BSL Studies'
  ],
  [
    'I decided to look further into a way of progressing quicker and more conveniently from home. I was pleasantly pleased the courses so convenient and the sessions were very flexible allowing me to go at my own speed.',
    'Amanda Crust',
    'Co Antrim, Belfast',
    'Level 3 BSL Training'
  ],
  [
    'The advantage of having a one to one tutorial is that the feedback you are given relates to you. I have found my online tutor is always willing to give this and has given me advice and assistance on both the educational and practical side of learning BSL.',
    'Minna Moffatt-Feldman',
    'Manchester',
    'Level 4 Certificate in English-BSL Bilingual Skills'
  ],
  [
    'BSLcourses offers high level, well structured British Sigh Language courses within a flexible online environment which boosts an up to date, well maintained and simple to use student dashboard.',
    'Kadine Brown',
    'London',
    'Level 6 NVQ Certificate in BSL'
  ],
  [
    'I sincerely commend the staff who have put together high quality courses and I am especially thankful for a supportive and flexible tutor who continues to offer late evening tutorial sessions.',
    'Lang Skrimshire',
    'Greenhithe, Kent',
    'Level 2 BSL Training.'
  ],
  [
    'The knowledge and skills I have gained is going to stand me in good stead for the rest of my studies and assist me in my career. I have and would recommend anyone to enrol with this training provider. Thumbs up from me!',
    'Pauline Shaw',
    'Wolverhampton',
    'Level 6 NVQ Certificate in BSL'
  ],
  [
    'This is an excellent framework for students to manage their progression on their chosen course based on their individual learning needs.',
    'Tina Kemp',
    'Enfield, Middlesex',
    'Level 6 NVQ Certificate in BSL'
  ],
  [
    'I completed my NVQ Level 6 BSL with BSLcourses and was delighted from start to finish with the service I received. I would highly recommend BSLcourses for any BSL training. Excellent value for money, thank you very much!',
    'Emma Lipton',
    'Leeds',
    'Level 6 NVQ Certificate in BSL'
  ],
  [
    'I am a Teacher for the Deaf in my area. My assessor was a wonderful teacher and made every effort to put me at ease and fit my tutorials around my schedule which was fantastic.',
    'Shelley Young',
    'Pocklington, East Yorkshire',
    'Levels 1, 2, 3 and 6 BSL Training; Level 6 NVQ Certificate in BSL'
  ]
];



// WEBPACK FOOTER //
// ./src/components/TestimonialsCarousel/testimonials.js